import type { FC } from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Box, Divider, Stack, Typography } from '@mui/material';

import { LOGIN_SSO_PROVIDER } from 'src/constants/settings';
import settings from 'src/settings';
import { routePaths } from 'src/services/routing/routePaths';
import AzureLogin from 'src/components/account/LoginPage/components/AzureLogin';
import GoogleLogin from 'src/components/account/LoginPage/components/GoogleLogin';
import LoginForm from 'src/components/account/LoginPage/components/LoginFormContainer';

import { styles } from './index.styles';

const LoginSelector: FC = () => {
  const { t } = useTranslation('login');

  const ssoProvider = settings.VITE_APP_LOGIN_SSO_PROVIDER;
  const useSingleSignOn = useMemo(
    () =>
      Object.values(LOGIN_SSO_PROVIDER).includes(
        ssoProvider as LOGIN_SSO_PROVIDER,
      ),
    [ssoProvider],
  );
  // The redirect is handled by the SurveyContext since it depends on the current survey
  const handleDone = () => {};

  return (
    <>
      <Typography variant="h1" sx={{ mb: 5 }}>
        {t('title')}
      </Typography>
      {useSingleSignOn && (
        <>
          <Typography variant="h4" sx={styles.loginFormTitle}>
            {t('oneClickLoginTitle')}
          </Typography>
          {ssoProvider === LOGIN_SSO_PROVIDER.AZURE && (
            <Stack direction="column" spacing={4} sx={{ pb: 4 }}>
              <AzureLogin onDone={handleDone} />
              <Divider>{t('or')}</Divider>
            </Stack>
          )}
          {ssoProvider === LOGIN_SSO_PROVIDER.GOOGLE && (
            <Stack direction="column" spacing={4} sx={{ pb: 4 }}>
              <GoogleLogin onDone={handleDone} />
              <Divider>{t('or')}</Divider>
            </Stack>
          )}
        </>
      )}

      <Typography variant="h4" sx={styles.loginFormTitle}>
        {t('emailTitle')}
      </Typography>

      <Box sx={{ mb: 2 }}>
        <LoginForm onDone={handleDone} />
      </Box>

      <Stack direction="row" sx={{ justifyContent: 'center' }}>
        <Box sx={styles.link} component={Link} to={routePaths.RESET}>
          {t('passwordReset')}
        </Box>
      </Stack>
    </>
  );
};

export default LoginSelector;
